import last from "lodash/last";

import { definedMap } from "@glideapps/ts-necessities";

import { assertNever } from "../support";
import type { SchemaInspector } from "./components";
import type {
    TableColumn,
    TableGlideType,
    SourceColumn,
    TableAndColumn,
    TableOrColumnsAndColumn,
} from "../common/description";
import { SourceColumnKind, getSourceColumnPath, getTableColumn, isSingleRelationType } from "../common/description";

export function resolveSourceColumn(
    schemaInspector: SchemaInspector,
    sc: SourceColumn,
    defaultTable: TableGlideType | undefined,
    containingScreenTable: TableGlideType | undefined
): readonly TableAndColumn[] | undefined;
export function resolveSourceColumn(
    schemaInspector: SchemaInspector,
    sc: SourceColumn,
    defaultTable: readonly TableColumn[] | TableGlideType | undefined,
    containingScreenTable: readonly TableColumn[] | TableGlideType | undefined
): readonly TableOrColumnsAndColumn[] | undefined;
export function resolveSourceColumn(
    schemaInspector: SchemaInspector,
    sc: SourceColumn,
    defaultTable: readonly TableColumn[] | TableGlideType | undefined,
    containingScreenTable: readonly TableColumn[] | TableGlideType | undefined
): readonly TableOrColumnsAndColumn[] | undefined {
    let table: readonly TableColumn[] | TableGlideType | undefined;
    if (sc.kind === SourceColumnKind.DefaultContext) {
        table = defaultTable;
    } else if (sc.kind === SourceColumnKind.UserProfile) {
        const tableName = schemaInspector.userProfileTableInfo?.tableName;
        if (tableName !== undefined) {
            table = schemaInspector.findTable(tableName);
        }
    } else if (sc.kind === SourceColumnKind.ContainingScreen) {
        table = containingScreenTable;
    } else {
        return assertNever(sc.kind);
    }

    const resolved: TableOrColumnsAndColumn[] = [];
    for (const columnName of getSourceColumnPath(sc)) {
        if (table === undefined) return undefined;

        const column = getTableColumn(table, columnName);
        if (column === undefined) return undefined;

        resolved.push({ table, column });

        if (isSingleRelationType(column.type)) {
            table = schemaInspector.findTable(column.type);
        }
    }

    return resolved;
}

export function getColumnForSourceColumn(
    schemaInspector: SchemaInspector,
    sc: SourceColumn,
    columnsOrTable: readonly TableColumn[] | TableGlideType | undefined,
    containingScreenColumnsOrTable: readonly TableColumn[] | TableGlideType | undefined
): TableColumn | undefined {
    const resolved = resolveSourceColumn(schemaInspector, sc, columnsOrTable, containingScreenColumnsOrTable);
    if (resolved === undefined) return undefined;
    return definedMap(resolved, last)?.column;
}
